const appendAuthType = (url: string) => {
  const authParam = "authType=lmClient";
  if (url.includes("?")) {
    return url.includes("authType=") ? url : `${url}&${authParam}`;
  }
  return `${url}?${authParam}`;
};

export const fetch2 = async (api: any, body: any) => {
  const urlWithAuth = typeof api === 'string' ? appendAuthType(api) : api;
  if (body) {
    let entries: any = Object.keys(body);
    let data = new FormData();
    for (let i of entries) {
      if (Array.isArray(body[i])) {
        for (let ele of body[i]) {
          data.append(i, ele);
        }
      } else {
        data.append(i, body[i]);
      }
    }
    const res = await fetch(urlWithAuth, {
      method: "post",
      credentials: "include",
      body: data,
    });
    return await res.json();
  } else {
    const res = await fetch(urlWithAuth, {
      method: "post",
      credentials: "include",
    });
    return await res.json();
  }
};

export const fetch3 = async (api: any, type: any) => {
  const urlWithAuth = typeof api === 'string' ? appendAuthType(api) : api;
  const res = await fetch(urlWithAuth, {
    method: type,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    mode: "cors",
    credentials: "include",
  });
  return await res.json();
};

export const fetch4 = async (api: any, body: any) => {
  const urlWithAuth = typeof api === 'string' ? appendAuthType(api) : api;
  if (body) {
    const res = await fetch(urlWithAuth, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      mode: "cors",
      body: JSON.stringify(body),
      credentials: "include",
    });
    return await res.json();
  } else {
    const res = await fetch(urlWithAuth, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      mode: "cors",
      credentials: "include",
    });
    return await res.json();
  }
};

export const fetch5 = async (api: any, type: string, body: any = {}) => {
  const urlWithAuth = typeof api === 'string' ? appendAuthType(api) : api;
  if (body) {
    const res = await fetch(urlWithAuth, {
      method: type,
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify(body),
    });
    const data = await res.json();

    if (data?.success === false) {
    throw data;
  }

  return data;
  } else {
    const res = await fetch(urlWithAuth, {
      method: type,
      headers: {
        "content-type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    return await res.json();
  }
};

export const fetch6 = async (api: any, body: any) => {
  const urlWithAuth = typeof api === 'string' ? appendAuthType(api) : api;
  if (body) {
    let entries: any = Object.keys(body);
    let data = new FormData();
    for (let i of entries) {
      if (Array.isArray(body[i])) {
        for (let ele of body[i]) {
          data.append(i, ele);
        }
      } else {
        data.append(i, body[i]);
      }
    }
    const res = await fetch(urlWithAuth, {
      method: "PATCH",
      credentials: "include",
      body: data,
    });
    return await res.json();
  } else {
    const res = await fetch(urlWithAuth, {
      method: "post",
      credentials: "include",
    });
    return await res.json();
  }
};

export const fetch7 = async (api: any, type: any, body: any) => {
  const urlWithAuth = typeof api === 'string' ? appendAuthType(api) : api;
  if (body) {
    let entries: any = Object.keys(body);
    let data = new FormData();
    for (let i of entries) {
      if (Array.isArray(body[i])) {
        for (let ele of body[i]) {
          data.append(i, ele);
        }
      } else {
        data.append(i, body[i]);
      }
    }
    const res = await fetch(urlWithAuth, {
      method: type,
      credentials: "include",
      body: data,
    });
    return await res.json();
  } else {
    const res = await fetch(urlWithAuth, {
      method: "post",
      credentials: "include",
    });
    return await res.json();
  }
};

export const fetch8 = async (
  api: string,
  method: string = "POST",
  body?: Record<string, any>
) => {
  const urlWithAuth = appendAuthType(api);
  const options: RequestInit = {
    method,
    credentials: "include",
  };

  if (body) {
    const data = new FormData();

    for (const key of Object.keys(body)) {
      const value = body[key];

      if (value === undefined || value === null) continue;

      if (Array.isArray(value)) {
        for (const item of value) {
          // If item is object, stringify it
          if (typeof item === "object") {
            data.append(`${key}[]`, JSON.stringify(item));
          } else {
            data.append(`${key}[]`, item);
          }
        }
      } else if (value instanceof File || value instanceof Blob) {
        data.append(key, value);
      } else if (typeof value === "object") {
        // objects -> JSON string
        data.append(key, JSON.stringify(value));
      } else {
        data.append(key, value);
      }
    }

    options.body = data;
  }

  const res = await fetch(urlWithAuth, options);
  return await res.json();
};
